// src/features/dashboard/components/charts/FeedbackCountTable/FeedbackCountTable.jsx
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import TableRowsRoundedIcon from "@mui/icons-material/TableRowsRounded";

import FeedbackTable from "../../../../../components/Charts/Table";
import ChartWrapper from "../../../../../components/common/ChartWrapper/ChartWrapper";
import ChartHeader from "../../../../../components/common/ChartHeader/ChartHeader";

import "../dashboardCharts.scss";

const FeedbackCountTable = () => {
  const { feedbackCount, feedbackCountFetching } = useSelector(
    (s) => s.dashboard,
  );
  const isEmpty = !feedbackCount;

  return (
    <Box
      backgroundColor="#ffffff"
      className=" chart-card feedback-count-table-container animate-card"
      p={3}
      borderRadius={3}
      boxShadow="0 1px 3px rgba(0,0,0,0.1)"
    >
      <ChartHeader
        icon={TableRowsRoundedIcon}
        title="Feedback Count by Users"
      />
      <ChartWrapper
        isLoading={feedbackCountFetching}
        isEmpty={isEmpty}
        height="394px"
      >
        <Box className="feedback-table-wrapper">
          <FeedbackTable data={feedbackCount} />
        </Box>
      </ChartWrapper>
    </Box>
  );
};

export default FeedbackCountTable;
